import { FC, HtmlHTMLAttributes } from "react"

import { cn } from "../../ui"

export const ContentLoader: FC<
    { width?: string; height?: string; margin?: string } & HtmlHTMLAttributes<HTMLDivElement>
> = ({ width, height, margin, className }) => {
    return (
        <div
            className={cn(
                "my-1 mx-0 inline-block h-full w-full animate-loader bg-[gray] bg-gradient-to-r from-[#828282] via-[#b3b3b3] to-[#828282] bg-50% opacity-10 first:mt-0 lg:duration-150",
                className
            )}
            style={{ height, width, margin }}
        />
    )
}
